import InputHomeUtp1 from "./InputHomeUtp1";
import CheckboxUtp1 from "@/components/UI/CheckboxUtp1";

export default [
    InputHomeUtp1,
    CheckboxUtp1
]
